import { ActivitiesAbility } from "@/abilities/activities/config/activities.ability";
import { AdminLinkAbility } from "@/abilities/admin-link/config/admin-link.ability";
import { AiAssistantAbility } from "@/abilities/ai-assistant/config/ai-assistant.ability.ts";
import { CollectionsAbility } from "@/abilities/collections/config/collections.ability";
import { DashboardAbility } from "@/abilities/dashboard/config/dashboard.ability";
import { DataProcessAbility } from "@/abilities/data-process/config/data-process.ability";
import { DocumentationAbility } from "@/abilities/documentation/config/documentation.ability";
import { GoAbility } from "@/abilities/go/config/go.ability";
import { MechanicAbility } from "@/abilities/mechanic/config/mechanic.ability";
import { PlayGroundAbility } from "@/abilities/playground/config/playground.ability";
import { ProductAndAssetAbility } from "@/abilities/product-and-asset/config/product-and-asset.ability";
import { SchematicViewerAbility } from "@/abilities/schematic-viewer/config/schematic-viewer.ability";
import { SearchAbility } from "@/abilities/search/config/search.ability";
import { ShopAbility } from "@/abilities/shop/config/shop.ability";
import { StaticPagesAbility } from "@/abilities/static-pages/config/static-pages.ability";
import { Ability } from "@/shared/environment/ability.types";

export function createAbilityList(): Array<Ability> {
    // Be careful when changing the order. The order of the Abilities also determines the order of the menu items and widgets and search tabs.
    // This behavior should be changed in the future.
    return [
        new DashboardAbility(),
        new AiAssistantAbility(),
        new ProductAndAssetAbility(),
        new MechanicAbility(),
        new SchematicViewerAbility(),
        new DocumentationAbility(),
        new ActivitiesAbility(),
        new CollectionsAbility(),
        new DataProcessAbility(),
        new PlayGroundAbility(),
        new SearchAbility(),
        new AdminLinkAbility(),
        new StaticPagesAbility(),
        new GoAbility(),
        new ShopAbility(),
    ];
}
